//////////////////////////////////////////////////////////////
// Record Screen

import m from "mithril";
import dayjs from 'dayjs'
import {filesize} from 'filesize'
import {loadContent} from "../Api";
import {defineWidget, NoticeWidget, Icon} from "@nebularstreams/libmui"

import {VideoPlayer} from "./misc/VideoPlayer";
import {TitleBarWidget} from "./misc/TitleBarWidget";
import {ContentBrowser} from "./misc/ContentBrowser";
import {StreamCard} from "./misc/StreamCard";

import {STATE_RECORD as STATE} from "../State";

//////////////////////////////////////////////////////////////

const {service: SERVICE} = STATE;

//////////////////////////////////////////////////////////////

/**
 * Load recordings in bucket
 * @param streamname Streamname
 */

function loadBucket(streamname) {

	if (STATE.streamname === streamname && STATE.content?.list?.length) {
		m.redraw();
		return;
	}

	STATE.loadingContent = true;
	m.redraw();
	loadContent(STATE, streamname, "mp4")
		.then(() => {
			STATE.streamname = streamname;
		})
		.catch((e) => {
			STATE.error = e.message;
		})
		.finally(() => {

			if (STATE.content?.list)
				STATE.content.list = STATE.content.list.sort((a, b) => new Date(a.date) < new Date(b.date) ? 1 : -1);

			STATE.loadingContent = false;
			m.redraw()
		});
}

//////////////////////////////////////////////////////////////

const

	// widget: The Bucket Item
	ContentItem = defineWidget(
		({attrs}) => m("li.flexrow.wm", {
			class: (STATE.currentItem === attrs.item) ? "selected" : "",
			onclick: () => {
				STATE.currentItem = attrs.item;
				m.redraw();
			}
		}, [
			m(Icon, {
				iconClass: "pad-1 pad-h", icon: "film",
			}),
			m("span.name.grows.ellipsis.ohidden", attrs.item.key),
			m("span.size.col-2", filesize(attrs.item.size)),
			m("span.date.col-2", dayjs(attrs.item.date).fromNow())
		])),


	// widget: Main Screen
	RecordScreen = defineWidget(
		({attrs}) => [
			m(TitleBarWidget, {
				title: "Recordings",
				rootTitle: "Studio",
				rootTitleClick: () => m.route.set(`/${attrs.orga}`)
			}),
			m(".flexcol.h-100.ohidden.grows", [

				m(StreamCard, {state: STATE, service: SERVICE, orga: attrs.orga, class: "firstlevel"}),

				// body
				m(".flexrow.ohidden.maincontainer", [

					...(STATE.content?.ts) ? [
						m(".flexcol.grows.ohidden.part-left", [
							// bucket list
							m(ContentBrowser, {
								state: STATE,
								noUpload: true,
								title: "Your Recordings in nanoStream Storage",
								itemWidget: ContentItem,
								emptyMessage: "No recorded clips for this streamname"

							})
						]),
					] : [],
					...STATE.currentItem || STATE.error
						? [
							m(".flexcol.part-right.grows", [

								...STATE.currentItem
									? [
										m(VideoPlayer, {
											state: STATE,
											item: STATE.currentItem,
											title: STATE.currentItem.key
										})
									]
									: [],

								...STATE.error
									? [
										m(NoticeWidget, {
											class: "rednotice marg-2 grows",
											icon: "exclamation-triangle",
											text: STATE.error,
											onClick: () => {
												if (STATE.errorFatal) delete STATE.streamname;
												delete STATE.error;
												m.redraw();
											}
										})
									] : []
							])
						] : []
				])
			])
		],
		({attrs}) => {

			STATE.service = SERVICE;

			document.title = "recordings - nanoStream Studio"

			if (attrs.key) {
				loadBucket(attrs.key);
			} else if (STATE.streamname) {
				m.route.set(`/${attrs.orga}/${SERVICE}/${STATE.streamname}`);
			}
		}
	);

export default RecordScreen;
